<template>
    <div>
        <div v-for="(newsItem, newsItemIndex) in newsItems"
             :key="'news-' + newsItemIndex"
             class="news-container pointer" @click="openNewsModal(newsItem)">
            <div class="flex justify-content-between">
                <div class="news-title">{{ newsItem.title }}</div>
                <div class="ml-3 news-published_at">{{ newsItem.published_at }}</div>
            </div>
        </div>
        <portal  v-if="showNewsModal" to="bodyModalContainer">
            <div class="modal" @keydown.esc="closeNewsModal" id="newsModal" tabindex="-1" role="dialog"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ selectedNewsItem.title }}</h5>
                            <button type="button" class="close" @click="closeNewsModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="ck-content" v-html="selectedNewsItem.content"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
    </div>
</template>

<script>
export default {
    name: "DashboardNewsExplorer",
    props: {
        newsItems: {
            type: Array,
            default: () => [],
        }
    },
    data: () => ({
        selectedNewsItem: null,
        showNewsModal: false,
    }),
    methods: {
        openNewsModal(newsItem) {
            this.selectedNewsItem = newsItem;
            this.showNewsModal = true;
            this.$nextTick(() => {
                $('#newsModal').modal('show')
            })
            axios.post(route('read.news', {news: newsItem.id}));
        },
        closeNewsModal() {
            $('#newsModal').modal('hide')
            this.showNewsModal = false;
            this.selectedNewsItem = null;
        }
    },
}
</script>

<style scoped>

.news-container {
    border-radius: 5px;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 1px solid lightgray;
    margin: 0.3rem 0;
}

.news-container:hover {
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1), -2px -2px 5px rgba(0, 0, 0, 0.1);
    background: white;
}

.news-title {
    color: grey;
    font-weight: 600;
    font-size: 0.9rem;
    text-align: left;
}

.news-published_at {
    color: grey;
    font-style: italic;
    font-size: 0.9rem;
    font-weight: 400;
}

.ck-content {
    color: grey;
    font-size: 0.9rem;
    font-weight: 600;
}

</style>
